<app-dialog [(visible)]="visible" header="Motif du rejet" width="480px" [dismissableMask]="true">
  <div class="reject-dialog-body">
    <p class="reject-dialog-hint">
      <i class="pi pi-exclamation-triangle"></i>
      Expliquez clairement pourquoi cette publicité est rejetée. L'annonceur en sera informé et pourra la corriger sans repayer.
    </p>
    <textarea pTextarea [ngModel]="text()" (ngModelChange)="text.set($event)" rows="4" class="reject-textarea"
              [placeholder]="placeholder()"></textarea>
  </div>
  <div dialogFooter>
    <button pButton [text]="true" (click)="cancel.emit()" label="Annuler"></button>
    <button pButton severity="danger" [disabled]="confirmDisabled()" [loading]="loading()"
            (click)="confirm.emit()" icon="pi pi-send" label="Confirmer le rejet"></button>
  </div>
</app-dialog>
